<div class="summernote-holder">
    <div id="{{id}}" class="summernote-editor"></div>
</div>